// layout constants for the bin widget.
// slot dimensions vary by layout mode.

// -- slot scale --------------------------------------------------------------

/** named slot size presets */
export type SlotScale = "xs" | "s" | "m" | "l" | "xl" | "xxl";

/** multiplier applied to base slot dimensions for each scale preset. s is
 *  left alone; m/l/xl each double the previous tier so the jump between
 *  sizes reads clearly. */
export const SLOT_SCALE_MULTIPLIERS: Record<SlotScale, number> = {
  xs: 0.5,
  s: 1,
  m: 2.5,
  l: 5,
  xl: 10,
  xxl: 20,
};

// -- grid mode (square tiles) ------------------------------------------------

/** grid cell size in pixels (square) */
export const GRID_CELL_SIZE = 84;

/** padding between cells in grid mode */
export const GRID_GAP = 4;

/** max characters for the filename label under grid cells */
export const GRID_LABEL_MAX_CHARS = 24;

/** font size for grid cell labels */
export const GRID_LABEL_FONT_SIZE = 9;

/** height reserved for the label text under grid cells */
export const GRID_LABEL_HEIGHT = 16;

// -- shelf mode (vertical spines) --------------------------------------------

/** shelf slot width (narrow vertical) */
export const SHELF_SLOT_W = 28;

/** shelf slot height */
export const SHELF_SLOT_H = 96;

/** gap between shelf slots */
export const SHELF_GAP = 2;

/** font size for shelf spine text (rotated) */
export const SHELF_FONT_SIZE = 8;

// -- crate mode (horizontal rows) --------------------------------------------

/** crate slot width */
export const CRATE_SLOT_W = 96;

/** crate slot height (narrow horizontal) */
export const CRATE_SLOT_H = 28;

/** gap between crate rows */
export const CRATE_GAP = 2;

/** font size for crate row text */
export const CRATE_FONT_SIZE = 9;

// -- drawer mode (full-width rows) -------------------------------------------

/** drawer row height (taller than crate for better readability) */
export const DRAWER_ROW_H = 36;

/** gap between drawer rows */
export const DRAWER_GAP = 2;

/** font size for drawer row text */
export const DRAWER_FONT_SIZE = 10;

// -- shared ------------------------------------------------------------------

/** padding around the content area inside the bin widget */
export const BIN_PADDING = 4;

// -- colors ------------------------------------------------------------------

/** background color for empty slots */
export const SLOT_EMPTY_BG = 0x1a1a1a;

/** border color for slot outlines */
export const SLOT_BORDER_COLOR = 0x2a2a2a;

/** default accent color when CompactInfo.accentColor is not provided */
export const DEFAULT_ACCENT_COLOR = 0x3a3a4a;

/** text color for labels */
export const TEXT_COLOR = 0xe0e0e0;

/** muted text color for secondary info */
export const TEXT_MUTED = 0x666666;
